
export class Terminal {
  id: number;
  tid: string;
  businessPremiseCode: string;
  businessPremiseAddress: string;
  companyName: string;
  isFiscal: boolean;
  haveInvoice: boolean;
  priceListId: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Terminal.ts